import React from "react";
import Footer from "../components/Footer";
import NewShipmentsGrid from "./Grid";
import CancelButton from "../components/Buttons/CancelButton";
import {
  getDataWithQueryString,
  postData,
} from "./../../../../api/componentAPIs";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import WithDrawer from "../../Dispatch/Common/Drawer/WithDrawer";
import { Button, CircularProgress, withStyles } from "@material-ui/core";
import Events from "../../../../utilities/EventEmitter";
import { isValid as isDateTimeValid } from "date-fns";
import { getPlanDateIBEtaCutOff } from "../PlanDateForm/utils";
import { getDefaultIBEtaCutOff } from "../IBBills/utils";
import appConstants from "../../../../appConstants";

const styles = (theme) => ({
  actionButton: {
    textTransform: "none",
    minWidth : 188,
    minHeight : 36
  },
  circularProgress: {
    color: theme.white,
  },
});
class NewShipments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newShipments: null,
      saveInProgress: false,
      ibEtaCutOff: null,
      errorMessage: appConstants.GRID_STATUS.LOADING,
    };
    this.gridApi = {};
  }

  componentDidMount() {
    this.loadInitializedPlanDates().then(initializedDates=>{
      const ibEtaCutOff = getPlanDateIBEtaCutOff(
        initializedDates,
        this.props.userData.userProfile.planDate
      );
      this.setState(
        {
          initializedDates,
          ibEtaCutOff: getDefaultIBEtaCutOff({
            ibEtaCutOff,
            planDate: this.props.userData.userProfile.planDate,
            defaultIBEtaCutOffTimeInMinutes:
              this.props.userData?.userProfile?.defaultIbEtaCutOffInMins ?? 0,
          }),
        },
        this.getNewShipmentsData
      );
    })
    Events.on("NewShipmentsDetected", this.getNewShipmentsData);
  }

  componentWillUnmount() {
    Events.off("NewShipmentsDetected", this.getNewShipmentsData);
  }

  getNewShipmentsData = () => {
    const {
      userData: { userProfile },
    } = this.props;
    getDataWithQueryString(
      "GetShipmentsToAdd",
      `terminalId=${userProfile.terminal.id}&terminalCode=${userProfile.terminal.code}&planDate=${userProfile.planDate}&ibEtaCutOff=${this.state.ibEtaCutOff}`
    ).then(
      (newShipments) => {
        if (newShipments && newShipments.status === 200) {
          this.setState({
            newShipments: newShipments.data,
            errorMessage : appConstants.GRID_STATUS.SUCCESS
          });
          this.selectPros();
        } else {
          this.props.enqueueSnackbar("Unable to fetch return shipments", {
            variant: "error",
          });
          this.setState({
            newShipments: [],
            errorMessage : appConstants.GRID_STATUS.ERROR
          });
        }
      },
      (_error) => {
        this.props.enqueueSnackbar("Unable to fetch return shipments", {
          variant: "error",
        });
        this.setState({
          newShipments: [],
          errorMessage : appConstants.GRID_STATUS.ERROR
        });
      }
    );
  };

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  selectPros = () => {
    this.gridApi.forEachNode((node) => {
      if (node.data.isInPlan) {
        node.setSelected(true);
      }
    });
  };

  handleError = (statusCode) => {
    if (statusCode !== 403) {
      this.props.enqueueSnackbar("Adding shipments to plan failed", {
        variant: "error",
      });
    }
    this.setState({
      saveInProgress: false,
    });
  };

  handleSubmit = () => {
    const selectedShipments = this.gridApi
      .getSelectedRows()
      .filter((pro) => !pro.isInPlan)
      .map((pro) => pro.proId);
    const reqData = {
      pros: selectedShipments,
      planDate: this.props.userData.userProfile.planDate,
      terminalId: this.props.userData.userProfile.terminal.id,
      ibEtaCutOff : this.state.ibEtaCutOff
    };
    this.setState({
      saveInProgress: true,
    });
    postData("AddShipmentsToPlan", reqData).then(
      (response) => {
        if (response?.status === 200) {
          this.setState({
            saveInProgress: false,
          });
          this.props.handleCancel();
        } else {
          this.handleError(response?.status);
        }
      },
      (_error) => {
        this.handleError();
      }
    );
  };

  onIBCutoffChanged = (value) => {
    if (value && value !== this.state.ibEtaCutOff && isDateTimeValid(value)) {
      this.setState(
        {
          ibEtaCutOff: value,
          newShipments : null,
          errorMessage : appConstants.GRID_STATUS.LOADING
        },
        this.getNewShipmentsData
      );
    }
  };

  loadInitializedPlanDates = () => {
    const {
      userData: { userProfile },
    } = this.props;
    return getDataWithQueryString(
      "GetInitializedPlanDates",
      `terminalId=${userProfile.terminal.id}`
    ).then((response) => {
      if (response?.status === 200) {
        return response.data;
      }
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        <NewShipmentsGrid
          rowData={this.state.newShipments}
          onGridReady={this.onGridReady}
          glEventHub={this.props.glEventHub}
          userProfile={this.props.userData.userProfile}
          serviceLevelList={this.props.serviceLevelList}
          ibEtaCutOff={this.state.ibEtaCutOff}
          onIBCutoffChanged={this.onIBCutoffChanged}
          showErrorMessage={this.state.errorMessage}
          gridApi={this.gridApi}
        />
        <Footer>
          <CancelButton onClick={this.props.handleCancel} />
          <Button
            classes={{
              root: classes.actionButton,
            }}
            variant="contained"
            color="primary"
            onClick={this.handleSubmit}
          >
            {this.state.saveInProgress ? (
              <CircularProgress
                size={16}
                classes={{ root: classes.circularProgress }}
              />
            ) : (
              "Add Shipments to Plan"
            )}
          </Button>
        </Footer>
      </>
    );
  }
}

export default compose(
  WithDrawer,
  withSnackbar,
  withUserProfile,
  withStyles(styles)
)(NewShipments);
